<script setup>
defineProps({
  fullBorder: {
    type: Boolean,
    default: true,
  },
  noBorder: Boolean,
  noPadding: Boolean,
})
</script>

<template>
  <div
    class="d-table relative block! overflow-auto"
    :class="{
      'full-border': fullBorder,
      'no-border': noBorder,
      'no-padding': noPadding,
    }"
  >
    <table class="w-full">
      <slot />
    </table>
  </div>
</template>

<style>
@reference '@/assets/style/index.css';

.d-table {
  table {
    thead {
      @apply text-left text-xs uppercase text-grey-400;

      tr {
        th {
          @apply align-middle font-normal;
        }
      }
    }

    tbody,
    tfoot {
      tr {
        th {
          @apply whitespace-nowrap font-medium;
        }

        td {
          @apply align-top;
        }
      }
    }
  }

  &:not(.no-padding) {
    table {
      thead {
        tr {
          th {
            @apply py-2 px-4;
          }
        }
      }

      tbody,
      tfoot {
        tr {
          th {
            @apply py-2 px-4;
          }

          td {
            @apply py-2 px-4;
          }
        }
      }
    }
  }

  &:not(.no-border) {
    table {
      thead {
        @apply border-y;
      }

      tbody,
      tfoot {
        tr {
          @apply border-y;
        }
      }
    }
  }

  &.full-border:not(.no-border) {
    table {
      thead {
        @apply border;
        tr {
          th {
            @apply border;
          }
        }
      }

      tbody,
      tfoot {
        tr {
          @apply border;
          th {
            @apply border;
          }

          td {
            @apply border;
          }
        }
      }
    }
  }
}
</style>
